export default {
  me: state => state.user
};